<template>
  <div name="reports">

    <div v-if="errored" class="ml-10 mt-4 font-bold text-red-400">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" class="mx-4" v-else>
      <div id="printable">

<section class="bg-white rounded w-full mx-auto px-6 pb-6 pt-4 mt-4 mb-8" v-if="hasAccess">

 <div class="flex justify-between">
   <div>
    <h2 class="text-xl font-semibold w-64 inline-block">
      Assessment Grades
      </h2>
      <div class="text-gray-500 pb-4">
        Assessment grades and totals.
      </div>
   </div>
   <div>
     <ul class="inline-block text-right">
   <li class="inline-block" v-for="item in gradesList" :key="item.key">
      <button  type="button" @click="filterGradeValue(item)"
      class="filter-bar-button hover:opacity-75 focus:outline-none"
      :style="setGradeBackColor(item)"
                    :class="setGradeTextColor(item)"> 
                       <i class="far" v-bind:class="inGradeFilter(item) ? 'fa-check-square': 'fa-square'" ></i> {{ item.value }}
                     </button>
   </li>
  </ul>
   </div>

  </div>
              <table v-if="componentLoaded" class="table-wrapper w-full">
                         <thead class="bg-gray-100 rounded">
                           <tr>
                             <th class="w-4/12 text-left p-2">Name</th>

                             <th v-for="item in criteriaList" :key="item.key" 
                             class="text-center  px-2">{{item.value}}</th>
                             <th class="w-2/12 text-center pl-2">Grade</th>
                           </tr>
                         </thead>
                         <tbody>
                           <tr class="course" v-for="(item, index) in filteredAssessments" :key="index"> 
                              <td > 
                               <div class="pl-2">
                                  {{ item.name }}
                              
                               </div>
                             </td>
                             <td v-for="criteria in criteriaList" :key="criteria.key" class="text-center bg-opacity-25 font-semibold" :style="setGradeColor(item[criteria.key], 0.25)">
                                 {{ parseToDecimal(item[criteria.key]) }}
                             </td>

                           <td :style="setGradeColor(item.final_grade, 0.25)" class="text-center font-bold bg-opacity-25 "  > {{ parseToDecimal(item.final_grade) }}</td>
                           </tr>
                             
                          
                         </tbody>
                         <tfoot>

                         </tfoot>
                       </table>
                       
                        <p v-else>We could not find any data for your given selection.</p>

   </section>
      <div v-else>
        <UpgradeContent :area="'Reporting'"></UpgradeContent>
      </div>

   </div>

    </div>

    <transition name="fade" v-if="!finishedLoading">
      <div class="loading">
        <span class="fa fa-spinner fa-spin"></span> Loading Reports
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ReportingService } from "@/services/reporting.service"

import { assessmentMixin } from "@/mixins/assessmentMixin.js";
const UpgradeContent = () => import("@/components/upgrade/UpgradeContent.vue");

export default {
  name: "reports",
  mixins: [assessmentMixin],
  props: ["filterValues", "hasAccess"],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings"
    }),
    componentLoaded() {
      return this.pupilAssessments.length > 0;
    },
    criteriaList() {
      if (this.settings.assessmentCriteriaList.length > 0) {
        return this.settings.assessmentCriteriaList.filter((c) => c.used === true );
      }
    },
    filteredAssessments() {
      let vm = this
      const data = vm.pupilAssessments.map((a) => a.pupil) 
      const results = data.map((d) => {
        var object = {name: d.name, final_grade: d.grades["final_grade"]}
        vm.criteriaList.forEach(function(c) {
          object[c.key] = d.grades[c.key]
          })
        return object
      })

        if (vm.filteredGrades.length == 0 ) {
         return _.orderBy(results, ["name"]);
      } else {
        let scores = vm.filteredGrades.map(s => s.score)


         var filtered = results.filter(function(aa) {
         
          let value = vm.gradeFromScore(aa.final_grade)
          if (value.length > 0) {
            return scores.includes(value[0].score)
          }
          
         });

         return _.orderBy(filtered, ["name"]);
    }
  }
  },
  data() {
    return {
      loading: true,
      finishedLoading: false,
      errored: false,
      pupilAssessments: [],
      filteredGrades: [],
      page: 1,
      pageSize: 999,
      currentPage: 1,
      pagination: {},
    };
  },
  created() {

  },
  mounted() {
    this.refresh()
  },
  watch: {
    loading(newValue) {
      setTimeout(() => {
        this.finishedLoading = !newValue;
      }, 2000);
    },
    '$props':{
      handler: function (val, oldVal) { 
        this.refresh()
      },
      deep: true
    }
  },
  methods: {
    refresh() {
      this.fetchAssessmentWithFilter()
    },
    async fetchAssessmentWithFilter() {

ReportingService.getAssessmentsWithFilter(this.filterValues, this.page, this.pageSize)
  .then((response) => this.buildAssessmentList(response.data.data))
  .catch((err) => {
    console.log("Activities " + err);
    this.errored = true;
  })
  .finally(() => (this.loading = false));
},
buildAssessmentList(data) {
this.pupilAssessments = data;
},
parseToDecimal(value) {
      if (value != undefined) {
        return value.toFixed(2)
      }
      
    },
    setGradeBackColor(grade) {
      return this.inGradeFilter(grade) 
      ? 'background-color:#' + grade.color + ';'
      : 'background-color:#fff'
    },
    setGradeTextColor(grade) {
      return this.inGradeFilter(grade) 
      ? 'text-white'
      : 'text-gray-500 hover:text-white hover:bg-' + grade.color
    },
    filterGradeValue(grade) {
      if (this.containsGrade(grade)) {
        this.filteredGrades.splice(this.filteredGrades.findIndex(item => item.key === grade.key), 1)
      } else {
        this.filteredGrades.push(grade);
      }
    },
    containsGrade(grade) {
      return this.filteredGrades.some(p => p.key === grade.key)
    },
    inGradeFilter(grade) {
      return this.containsGrade(grade)
    },
  },
  components: {
UpgradeContent
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upper {
  text-transform: uppercase;
}

.smaller {
  font-size: 75% !important;
}

select {
  font-weight: bolder;
  font-size: 13pt;
  display: inline !important;
}

td {
  border-left: 1px solid rgba(230, 236, 245, 0.75) !important;
}
</style>
